import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/compliance/incidents', params, replace: true });
    },
});
